import * as React from 'react';
import { createComponent } from '@lit/react';
import { ResourceCardWC } from './resource-card.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../../components/component-types-generics';

export type ResourceCardProps =
  GenerateComponentTypeWithChildren<ResourceCardWC> & {
    onClick?: React.MouseEventHandler<ResourceCardWC>;
  };

export type ResourceCardPropsWithRef = GeneratePropsWithRef<ResourceCardProps>;

export const ResourceCard = createComponent({
  tagName: ResourceCardWC.tagname,
  elementClass: ResourceCardWC,
  react: React,
  events: {
    onClick: 'click',
  },
}) as ResourceCardPropsWithRef;
